import { message } from "antd";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import uri from "../../constants/uri";
import actions from "../actions/actions";

const getNoticesList = (noticeId) => async (dispatch) => {
	try {
		dispatch({ type: actions.DEBTS_LIST_LOADING });
		const response = await client.get(`${uri}/notification_receivables`, {
			headers: authHeader(),
			params: {
				notificationId: noticeId,
			},
		});
		dispatch({
			type: actions.DEBTS_LIST_LOADED,
			payload: response.data.map((debt) => ({
				...debt,
				address: `${debt.street}, ${debt.house}, ${
					debt.flat ? `кв ${debt.flat}` : ""
				}`,
			})),
		});
	} catch (error) {
		console.error(error);
		message.error("При загрузке списка оповещений произошла ошибка");
	}
};

export default getNoticesList;
